import React from "react";
import "./StartRapidHeader.css";

const RapidFireCard = ({
  title = "Rapid Fire",
  location = "Himachal Pradesh",
  category = "Rapid Fire",
  description = "",
  available = true,
  usedToday = 0,
  leftToday = 5,
  attempts = 0,
  totalAttempts = 5,
  limitMessage = "",
  onStart,
}) => {
  const remainingAttempts = Math.max(0, totalAttempts - usedToday);

  return (
    <>
      <style>{`
        .rapid-fire-card {
          padding: 20px 0px;
        }
    `}</style>
 
    <div className="rapid-fire-card">
      <div className="rapid-fire-header">
        <h1 className="qb-title">
          {title.split(" ").slice(0, -1).join(" ") || title} <span>{title.split(" ").slice(-1).join(" ")}</span>
        </h1>

        <span className="rapid-fire-status">
          {available ? "Available" : "Unavailable"}
        </span>
      </div>

      <div className="rapid-fire-location">
        {location} / {category}
      </div>

      <p className="rapid-fire-description">
        {description}
      </p>

      <div className="start-header-btns">
        <div className="rapid-fire-stats">
          <div className="rapid-fire-stat">
            <strong>{usedToday}</strong>
            <span>Used today</span>
          </div>

          <div className="rapid-fire-stat">
            <strong>{leftToday}</strong>
            <span>Left today</span>
          </div>

          <div className="rapid-fire-stat">
            <strong>{attempts}</strong>
            <span>Attempts</span>
          </div>
        </div>

        <div 
          className="start-rapid-fire" 
          onClick={onStart}
          style={{ cursor: "pointer" }}
        >
          <div className="start-rapid-fire-icon">
            ?
          </div>

          <div className="start-rapid-fire-content">
            <strong>Start Rapid Fire</strong>
            <span>Timed practice with quick questions</span>
          </div>

          <div className="start-rapid-fire-arrow">
            <i className="bi bi-arrow-right-short"></i>
          </div>
        </div>
      </div>

      <div className="rapid-fire-attempt-info">
        {usedToday} of {totalAttempts} daily attempts used
      </div>

      <div className="rapid-fire-remaining">
        {limitMessage || `You have ${remainingAttempts} attempts remaining for today.`}
      </div>
    </div>
       </>
  );
};

export default RapidFireCard;
